'use client';

import Image, {type ImageProps} from 'next/image';
import {useState} from 'react';

// Keep recovery state local to a source: changing a card or gallery image must
// give the new image a fresh attempt, even if the previous source failed.
export function ContentImage(props: ImageProps) {
  const source =
    typeof props.src === 'string' ? props.src : 'default' in props.src ? props.src.default.src : props.src.src;
  return <RecoverableImage key={source} {...props} />;
}

function RecoverableImage({src, alt, onError, unoptimized, ...props}: ImageProps) {
  const [recovery, setRecovery] = useState<'optimized' | 'original' | 'failed'>('optimized');
  const isPdf = typeof src === 'string' && /\.pdf(?:[?#]|$)/i.test(src);

  if (isPdf || recovery === 'failed') {
    return (
      <div
        className="absolute inset-0 bg-midground2"
        role={alt ? 'img' : undefined}
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
      />
    );
  }

  return (
    <Image
      {...props}
      src={src}
      alt={alt}
      unoptimized={unoptimized === true || recovery === 'original'}
      onError={event => {
        // Retry the original only once. A broken source must not create a loop.
        setRecovery(recovery === 'optimized' && !unoptimized ? 'original' : 'failed');
        onError?.(event);
      }}
    />
  );
}
